import React from 'react'
import { ReactComponent as CameraIcon } from '../../../../../assets/svg/icons/icn-camera.svg'
import Avatar from '../../../../ui/images/Avatar'
import { Button } from 'react-bootstrap'

import '../../../../../assets/sass/pages/profile-settings/components/editable-image.scss'

const EditableImage = ({
    editIcon: Icon = CameraIcon,
    onClick = () => console.log('clicked'),
    ...props
}) => {
    return (
        <div className="editable-image">
            <Avatar {...props} />
            <Button className="edit-icon-container" href="#" onClick={onClick} variant="dark">
                <Icon className="edit-icon" />
            </Button>
        </div>
    )
}

export default EditableImage
